import { Link } from 'react-router-dom'

import { ROUTES } from '../../../routes/types'

interface LogoProps {
  customLogoUrl?: string | null
  /** `sm` (default) for the app/auth header bar; `lg` for the centered auth-page logo. */
  size?: 'sm' | 'lg'
  /** Accessible alt for a custom logo image (e.g. the org name). Ignored for the wordmark. */
  alt?: string
}

const SIZES = {
  sm: { maxWidth: 120, imgMaxHeight: 40, imgMaxWidth: 120, text: 'text-2xl' },
  lg: { maxWidth: 220, imgMaxHeight: 56, imgMaxWidth: 220, text: 'text-4xl' },
} as const

export function Logo({ customLogoUrl, size = 'sm', alt = 'Logo' }: LogoProps) {
  const s = SIZES[size]

  return (
    <Link to={ROUTES.HOME} className="flex shrink-0 items-center" style={{ maxWidth: s.maxWidth }}>
      {customLogoUrl ? (
        <img
          src={customLogoUrl}
          alt={alt}
          className="object-contain"
          style={{ maxHeight: s.imgMaxHeight, maxWidth: s.imgMaxWidth }}
        />
      ) : (
        <span
          className={`font-display ${s.text} font-bold`}
          style={{
            background: 'linear-gradient(120deg, #1c99fe 20.69%, #7644ff 50.19%, #fd4766 79.69%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          Gisify
        </span>
      )}
    </Link>
  )
}
